var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#001627",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    d: "M10.095 1.968a1 1 0 0 1 1.81 0l2.267 4.82a1 1 0 0 0 .753.562l5.15.79a1 1 0 0 1 .562 1.688l-3.783 3.866a1 1 0 0 0-.272.86l.884 5.41a1 1 0 0 1-1.47 1.037l-4.513-2.49a1 1 0 0 0-.966 0l-4.513 2.49a1 1 0 0 1-1.47-1.037l.884-5.41a1 1 0 0 0-.272-.86L1.363 9.828a1 1 0 0 1 .563-1.688l5.148-.79a1 1 0 0 0 .754-.563z"
  })));
};
export default SvgStar;